import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EarhivUiComponents } from '@app/shared/models/earhiv-ui-components';
import { BehaviorSubject, switchMap, tap } from 'rxjs';
import { CommonListGridViewComponent } from '../common-list-grid-view/common-list-grid-view.component';

@Component({
  selector: 'app-jedinica-gradiva-list-grid-view',
  templateUrl: './jedinica-gradiva-list-grid-view.component.html',
  styleUrls: ['./jedinica-gradiva-list-grid-view.component.css']
})
export class JedinicaGradivaListGridViewComponent
  extends CommonListGridViewComponent
  implements OnInit
{
  override tableCompId: string = EarhivUiComponents.TABLE_LIST_GRID_VIEW;

  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private routeState: any = {};
  opciiliMoj = 'Opći inventar';

  private resultsVisible = new BehaviorSubject(
    this.router.url === '/view/jedinica_gradiva' ||
      this.router.url === '/view/moje_gradivo'
  );

  resultsVisible$ = this.resultsVisible.asObservable();

  override ngOnInit(): void {
    super.ngOnInit();
    this.initResetToPretragaSubscription();
    const state = this.router.lastSuccessfulNavigation?.extras?.state;
    if (state) {
      this.routeState = state;
    }
    if (this.route.snapshot.data['isMojeGradivo']) {
      this.opciiliMoj = 'Moji fondovi i zbirke';
    }
  }

  private initResetToPretragaSubscription() {
    this.addSubscription(
      this.route.data
        .pipe(
          switchMap(() => {
            return this.filterViewProviderDirective.viewData$.pipe(
              tap(() => {
                if (
                  this.router.url !== '/view/jedinica_gradiva' &&
                  this.router.url !== '/view/moje_gradivo'
                ) {
                  const searchRoute =
                    this.route.snapshot.data['isMojeGradivo'] ||
                    this.routeState['isMojeGradivo']
                      ? '/view/moje_gradivo'
                      : '/view/jedinica_gradiva';
                  this.router.navigate([searchRoute]);
                  this.resultsVisible.next(true);
                }
              })
            );
          })
        )
        .subscribe()
    );
  }

  pregledPremaStrukturi(): void {
    this.closeAdvancedSearch();
    this.router.navigate(['hierarhija'], {
      relativeTo: this.route,
      state: {
        isMojeGradivo: this.route.snapshot.data['isMojeGradivo'] || false
      }
    });
  }

  pregledPremaKlasifikaciji(): void {
    this.closeAdvancedSearch();
    this.router.navigate(['hierarhija-klasifikacija'], {
      relativeTo: this.route,
      state: {
        isMojeGradivo: this.route.snapshot.data['isMojeGradivo'] || false
      }
    });
  }

  private closeAdvancedSearch() {
    // TODO dodati na komponentu u ntap metodu closeSearch()
    const filterComp: any = this.filterContainer.getViewComponent();
    const fieldset: HTMLElement =
      filterComp.elRef.nativeElement.children[0].children[0];
    const filterBtn: HTMLElement = fieldset.children[0]
      .children[0] as HTMLElement;
    if (fieldset.classList.contains('p-fieldset-expanded')) {
      filterBtn.click();
    }
    this.resultsVisible.next(false);
  }
}
